import React from 'react'
import { MarketBars } from './MarketBars'

type KpiCardProps = {
    label: string
    value: string
    unit?: string
    note?: string
    markets?: Array<{ code: string; widthPct: number; value: string }> | null
    dashed?: boolean
    headerAccessory?: React.ReactNode
}

export const KpiCard: React.FC<KpiCardProps> = ({ label, value, unit, note, markets, dashed, headerAccessory }) => (
    <div
        className={`bg-white rounded-2xl p-4 flex flex-col gap-1.5 ${
            dashed ? 'border border-dashed border-neutralBlack-300' : 'border border-neutralBlack-200 shadow-sm'
        }`}
    >
        <div className="flex items-center gap-2 flex-wrap">
            <span className="flex-1 min-w-0 text-[11.5px] font-medium tracking-wide uppercase text-neutralBlack-500">{label}</span>
            {headerAccessory}
        </div>
        <div className="flex items-baseline gap-1.5">
            <span className="text-[26px] font-semibold tracking-tight text-neutralBlack-900">{value}</span>
            {unit && <span className="text-[13px] text-neutralBlack-600">{unit}</span>}
        </div>
        {note && <span className="text-[12.5px] text-neutralBlack-600">{note}</span>}
        {markets && <MarketBars items={markets} />}
    </div>
)
